import React from 'react'
import styled from 'styled-components'
import { media } from '../styles/vars'

const Container = styled.div`
.article-video-wrp{
    direction:ltr;
}
#artiheader {
    color: #2d3544;
    font-weight: 700;
    border: 3px solid #2d3544;
    border-left: none;
    border-right: none;
    margin-bottom: 60px;
    padding: 20px 0;
}
#artiheader h1{
    font-size:52px;
}
#artiheader h2{
    font-size:23px;
    line-height:1.2;
}
#artiheader h3{
    margin-top:30px;
    font-size:27px;
}
#artiheader .heighlight_a{
    font-weight:100;
    font-size:20px;
}
.artiwrapper span, .artiwrapper strong, .artiwrapper font{
    font-size: 22px !important;
    line-height: 1.2 !important;
}
.artiwrapper .article_media.caption-img-container{
    margin-bottom:20px;
}
.artiwrapper .article_media.caption-img-container .rtl{
    margin-top:20px;
    display:block;
}
.artiwrapper .article_media.caption-img-container .rtl strong{
    font-weight:700 !important;
    font-size: 24px !important;
}

.artiwrapper .pHeader{
    color: #da1818;
    font-weight: 700;
}

.artiwrapper img{
    display:block;
    width:100%;
}
.iframe-wrp{
    position: relative;
	padding-bottom: 56.25%;
    height: 0;
    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;        
    }
}
${
    media.desktop`
    #artiheader{
        padding:40px 0;
    }
    #artiheader h1{
        font-size:92px;
    }
    #artiheader h2{
        font-size:30px;
    }
    #artiheader h3{
        font-size:32px;
    }
    #artiheader .heighlight_a{
        font-size:26px;
    }
    .artiwrapper span, .artiwrapper strong, .artiwrapper font{
        font-size: 30px !important;
    }
    .artiwrapper .article_media.caption-img-container .rtl strong{
        font-size: 34px !important;
    }
    `
    }
`
const ArticleHtml = (props) => {
    return (
        <Container dangerouslySetInnerHTML={{ __html: props.html }}></Container>
    )
}

export default ArticleHtml;


// WEBPACK FOOTER //
// ./src/components/ArticleHtml.jsx